import React from 'react';

export default function useStatusFilter<T = string | undefined>(
  initialValue: T,
  setPage?: React.Dispatch<React.SetStateAction<number>>,
): [T, (value: T) => void] {
  const [status, _setStatus] = React.useState<T>(initialValue);
  const setStatus = React.useCallback(
    (value: T) => {
      _setStatus(value);
      setPage?.(1);
    },
    [setPage],
  );
  return [status, setStatus];
}
